// React
import React, { useEffect, useState, useRef } from "react";

// Libraries
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";

// Components
import Text from "@Components/Text";

// Utils
import { getTimerLabel } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

const VoiceNote = ({ recorderControls, onRecordingComplete }) => {
	const [send, setSend] = useState(false);
	const [visible, setVisible] = useState(false);
	const blinking = useRef(null);

	const { startRecording, stopRecording, togglePauseResume, recordingBlob, isRecording, isPaused, recordingTime, setRecordingBlob } =
		recorderControls;

	useEffect(() => {
		if (recordingBlob !== undefined && send) {
			onRecordingComplete(recordingBlob);
			setRecordingBlob(undefined);
		}
	}, [recordingBlob]);

	useEffect(() => {
		if (isRecording && !isPaused) {
			blinking.current = setInterval(() => {
				setVisible((prev) => {
					return !prev;
				});
			}, 500);
		} else {
			clearInterval(blinking.current);
			setVisible(false);
		}

		return () => {
			clearInterval(blinking.current);
		};
	}, [isRecording, isPaused]);

	const handleStop = (willSend = false) => {
		setSend(willSend);
		stopRecording();
	};

	if (isRecording) {
		return (
			<div className={styles.extendedContainer}>
				<div
					className={styles.buttonIconContainer}
					role="button"
					tabIndex="-1"
					onClick={() => {
						return handleStop(false);
					}}>
					<Icon name="trash" size="large" color="red" />
				</div>
				<div className={styles.row}>
					<div className={styles.redZone} style={{ visibility: visible ? "visible" : "hidden" }}>
						<div className={styles.redDot} />
					</div>
					<Text>{getTimerLabel(recordingTime)}</Text>
				</div>
				<div className={styles.row}>
					<div className={styles.buttonIconContainer} role="button" tabIndex="-1" onClick={togglePauseResume}>
						<Icon name={isPaused ? "play" : "pause"} size="large" />
					</div>
					<div className={styles.divider} />
					<div
						className={styles.buttonIconContainer}
						role="button"
						tabIndex="-1"
						onClick={() => {
							return handleStop(true);
						}}>
						<Icon name="send" size="large" />
					</div>
				</div>
			</div>
		);
	}
	return (
		<div className={styles.container} role="button" tabIndex="-1" onClick={startRecording}>
			<Icon name="microphone" size="large" />
		</div>
	);
};

VoiceNote.propTypes = {
	recorderControls: PropTypes.object,
	onRecordingComplete: PropTypes.func,
};

export default VoiceNote;
